import * as keyapis_telemetry_alerting_v1_events_pb from "./v1/keyapis_telemetry_alerting_events_v1.pb";
import * as keyapis_telemetry_alerting_v1_system_pb from "./v1/keyapis_telemetry_alerting_system_v1.pb";
import * as keyapis_telemetry_alerting_v1_trigger_pb from "./v1/keyapis_telemetry_alerting_trigger_v1.pb";

export default {
  v1: {
    resources: {
      events: keyapis_telemetry_alerting_v1_events_pb,
      system: keyapis_telemetry_alerting_v1_system_pb,
      trigger: keyapis_telemetry_alerting_v1_trigger_pb,
    },
  },
};
